import React from 'react';

import { fontProp } from 'components/propTypesConsts';

import { CustomFontWrapper } from '../CustomFontWrapper/CustomFontWrapper';

import { Box, Typography } from './style';

export function FontPreview({ font }) {
  return (
    <CustomFontWrapper font={font}>
      <Box>
        <Typography className="title" variant="caption">
          {font.name}
        </Typography>
        <Typography>Almost before we knew it, we had left the ground.</Typography>
      </Box>
    </CustomFontWrapper>
  );
}

FontPreview.propTypes = {
  font: fontProp.isRequired,
};
